/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Token obtain pair serializer specific for guest user instances.
 * This serializer inherits all functionality from its parent serializers and
 * only overrides the username_field config variable.
 * @export
 * @interface APIOrgUserTokenObtainPairRequest
 */
export interface APIOrgUserTokenObtainPairRequest {
    /**
     * 
     * @type {string}
     * @memberof APIOrgUserTokenObtainPairRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof APIOrgUserTokenObtainPairRequest
     */
    password: string;
}

/**
 * Check if a given object implements the APIOrgUserTokenObtainPairRequest interface.
 */
export function instanceOfAPIOrgUserTokenObtainPairRequest(value: object): value is APIOrgUserTokenObtainPairRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function APIOrgUserTokenObtainPairRequestFromJSON(json: any): APIOrgUserTokenObtainPairRequest {
    return APIOrgUserTokenObtainPairRequestFromJSONTyped(json, false);
}

export function APIOrgUserTokenObtainPairRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIOrgUserTokenObtainPairRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
    };
}

export function APIOrgUserTokenObtainPairRequestToJSON(value?: APIOrgUserTokenObtainPairRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'password': value['password'],
    };
}

